import { useMiiaFwStore } from '@/stores/miiaFwStore'
import type { RefreshState } from '../types/miiaFwStore/state'
import type { RouteRecordNormalized } from 'vue-router'

export const useMiiaFwStoreUtils = () => {
  /**
   * Vuexにストアされている'miiaFwStore/updateRefreshState'を書き換える。
   * トークンのリフレッシュ処理が必要な時にtrueに切り変わる。
   * @param onRefresh リフレッシュ処理が必要かどうか
   * @param errorMessage リフレッシュ処理の際にエラーが発生した時に格納するエラーメッセージ。
   */
  const updateRefreshState = (
    onRefresh: boolean | RefreshState,
    errorMessage?: string | undefined | null
  ): void => {
    if (!errorMessage === undefined) {
      const miiaFwStore = useMiiaFwStore()
      miiaFwStore.updateRefreshState(
        typeof onRefresh === 'boolean' ? { onRefresh: onRefresh } : onRefresh
      )
    } else {
      const miiaFwStore = useMiiaFwStore()
      miiaFwStore.updateRefreshState(
        typeof onRefresh === 'boolean'
          ? {
              onRefresh: onRefresh,
              error: errorMessage
            }
          : onRefresh
      )
    }
  }

  /**
   * Vuexにストアされている'miiaFwStore/updateMenu'を更新する。
   * 表示するメニュー項目の設定を行うときに実行する。
   * @param menu VueRouterのroutesの要素を並べた配列。
   */
  const updateMenu = (menu: RouteRecordNormalized[]): void => {
    const miiaFwStore = useMiiaFwStore()
    miiaFwStore.updateMenu(menu)
  }

  /**
   * Vuexにストアされている'miiaFwStore/updateSensitiveInfo'を更新する。
   * センシティブ情報を設定するときに使用する
   * @param obj センシティブ情報
   */
  const updateSensitiveInfo = (obj: { [key: string]: string }): void => {
    const miiaFwStore = useMiiaFwStore()
    miiaFwStore.updateSensitiveInfo(obj)
  }

  return {
    updateRefreshState,
    updateMenu,
    updateSensitiveInfo
  }
}
